// App Imports
import mediaGallery from './list'

const index = {
  mediaGallery
}
export default index;